<template>
  <v-app id="inspire">
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
        <v-row>
          <v-col  md="12" lg="12" cols="12">
            <v-card color="#393E46">
              <v-card-title>Reportes</v-card-title>
              <v-card-subtitle>Ranking Asistencias</v-card-subtitle>
              <v-card-actions>   <vue-excel-xlsx
                  class   = "btn"
                  :data="asistencias"
                  :columns="columns"
                  file-name="Asistencia"
                  :file-type="'xlsx'"
                  :sheet-name="'Asistencia'"
              >
                <v-btn  style="background-color: #6D9886;"> Bajar Excel</v-btn>
              </vue-excel-xlsx></v-card-actions>
              <v-card-text>
                <v-row>
                  <v-col md="3" lg="3" cols="6">
                    <v-autocomplete
                        v-model="idfiesta"
                        :items="fiestas"
                        item-text="nombre"
                        item-value="id"
                        label="Escoge Fiesta"
                        persistent-hint
                        single-line
                        @change="dameasistencias"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col  md="12" lg="12" cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="asistencias"
                        class="elevation-1"
                        :loading="progr"
                        no-data-text="No hay datos disponibles para mostrar."
                        no-results-text="No hay resultados para la búsqueda."
                        loading-text="Cargando... Por favor espere."
                        style="background-color: #393E46;"

                    >
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <leftmenu :abreviado="abreviado" />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import leftmenu from '../../general/leftmenu';
import axios from "axios";
import firebase from 'firebase/compat/app';
import {mapGetters} from "vuex";
import Cabecerabaja from "@/components/general/cabecerabaja";


export default {
  title: 'Reportes Asistencia | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    leftmenu
  },
  data: () => ({
    drawer: null,
    idnegocio: 0,
    idfiesta:0,
    token:'',
    fecha: null,
    menu1: false,
    asistencias:[],
    fiestas:[],
    overlay:false,
    abreviado:'NN',
    progr:true,
    date: new Date().toISOString().substr(0, 10),
    columns : [
      {
        label: "Nombre",
        field: "nombre",
      },
      {
        label: "Email",
        field: "email",
      },
      {
        label: "Telefono",
        field: "telefono",
      }
    ],
    headers: [
      { text: 'Nombre', value: 'nombre', sortable: true },
      { text: 'Email', value: 'email', sortable: true },
      { text: 'Telefono', value: 'telefono', sortable: true }
    ],
  }),
  mounted() {
    this.idnegocio =  this.$route.params.idnegocio;
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

              this.damefiestas();
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

      this.damefiestas();
      }
  },
  methods:{
    damefiestas(){
      this.progr = true;
      let urlfiesta = 'actos/fiestas/negociotag/' + this.idnegocio ;
      axios
          .get(urlfiesta,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.fiestas = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
            this.progr = false;
          });
    },
    dameasistencias(){
      this.overlay = true;
      this.progr = true;
      let urlfiesta = 'personas/asistencia/' + this.idfiesta ;
      axios
          .get(urlfiesta,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.asistencias = response.data;
            this.overlay = false;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false
            this.progr = false;
          });
    },

  },
  computed:{
    ...mapGetters({
      user: "user",
      usuario: "usuario"
    })
  }
};
</script>
